const value = {
    nameTitle: 'Наименование продукта/проекта',
    nameSubtitle: 'Данное поле должно содержать полное наименование Проекта/Продукта.',
    idTitle: 'Идентификатор продукта/проекта',
    idSubtitle:
      'Данное поле должно содержать уникальный идентификатор проекта/продукта в организации. В случае отсутствия кода указывается “Отсутствует“.',
    jiraLinkTitle: 'Ссылка на проект в Jira',
    jiraLinkSubtitle: 'Ссылка на страницу проекта/продукта в Jira.',
    summaryTitle: 'Краткое описание',
    summarySubtitle: 'Любая дополнительная информация по проекту.',
  };

export default value;
